<div
  style="
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
  "
>
  <mat-card style="flex: 1 1 85%; max-width: 85%" class="seneca-card">
    <div class="seneca-content-padding">
      <div
        style="
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: center;
          align-items: flex-start;
          height: 100%;
        "
      >
        <div
          class="header-container"
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            flex: 0 1 70%;
          "
        >
          <h2 class="center-align">
            <span>
              Your Application has been submitted. Thank you for applying to
              Seneca Polytechnic.</span
            >
          </h2>
        </div>

        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            flex: 1 1 100%;
          "
        >
          <mat-card-content
            class="seneca-card-content"
            style="
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              height: 100%;
              gap: 2em;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: stretch;
                gap: 2em;
                height: 100%;
              "
            >
              <div *ngIf="showAutoEvalButton">
                <b>Expedited Processing</b>
                <br />Your application may be eligible for a faster processing
                by providing more information.<br />
                <div></div>
                <input
                  type="checkbox"
                  [disabled]="isDisabled"
                  (change)="userWantsAE()"
                />
                <label for="checkbox"
                  >Yes, I would like provide more information</label
                >
                <div *ngIf="userPressedAutoEval">
                  Within 24 hours after the payment, you can enter more
                  information to help us better understand your background here:
                  <a [href]="autoEvalUrl + '/' + guid" target="_blank">{{
                    autoEvalUrl
                  }}</a>
                </div>
                <br />
                Otherwise, you may leave this screen after reviewing the
                following notes.
              </div>
              <ul
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  gap: 1em;
                "
              >
                <li>
                  We prioritize review of applications based on several
                  criteria. These include completeness of the application as
                  well as availability of seats in the desired programs. If
                  there are more qualified applicants than seats, applications
                  are ranked based on the quality of verified grades and
                  language scores. Applications are not reviewed on a first
                  come, first served basis, which results in varied and
                  undefined processing times.
                </li>
                <li *ngIf="userType === userTypeEnum.Applicant">
                  You will receive your Seneca Student ID and information about
                  how to set up your Seneca online services about 24 hours after
                  you apply. It is important that you set up your account as
                  soon as possible, as critical information regarding the status
                  of your application will be communicated through your Seneca
                  online
                  <a href="https://senecapolytechnic.ca/student-centre">
                    Student Home
                  </a>
                </li>
                <li *ngIf="userType === userTypeEnum.Applicant; else showAgent">
                  Important communications will be sent to you by email to the
                  address provided in your application.
                </li>
                <ng-template #showAgent>
                  <li>
                    Important communications will be sent to the email address
                    that was provided in the application, and you will be
                    granted access to view the application updates through your
                    Seneca online Agent Portal.
                  </li>
                </ng-template>
              </ul>
              <ul
                class="disable-list-styling"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <li><b>International Admissions Office</b></li>
                <li>
                  <b>Phone: +1 (416) 764-9900</b>
                </li>
                <li><b>Email: theservicehub&#64;senecapolytechnic.ca</b></li>
                <li>
                  <i
                    >Please provide application confirmation number when
                    contacting us.</i
                  >
                </li>
              </ul>
            </div>

            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                height: 100%;
                width: 100%;
              "
            >
              <mat-card-actions
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-around;
                  width: 100%;
                "
              >
                <button (click)="onClose()" mat-raised-button color="secondary">
                  Close
                </button>
                <button (click)="onBack()" mat-raised-button color="primary">
                  {{ isApplicant() ? "My Application" : "Return to Dashboard" }}
                </button>
              </mat-card-actions>
            </div>
          </mat-card-content>
        </div>
      </div>
    </div>
  </mat-card>
</div>
